import GradientText from 'components/GradientText';
import { Button } from 'components/buttons/Button/Button';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import EuropeFlag from 'images/small-images-inside-text/EuropeFlag.jpg';
import GermanFlag from 'images/small-images-inside-text/GermanFlag.jpg';
import './styles.scss';

const AboutUs = () => (
    <section className="container">
        <div className="inner-container type-2">
            <div className="main-text-container">
                <LabelButton>About us</LabelButton>
                <GradientText>
                    A family business philosophy <br />
                    <em>
                        born in <img src={EuropeFlag} alt="decor" /> Europe
                    </em>
                    , with solutions{' '}
                    <em>
                        made in <img src={GermanFlag} alt="German flag" /> Germany
                    </em>
                </GradientText>
                <div className="offset-left-4">
                    <GradientText size="small">
                        We’re part of a global movement of people, organizations, and companies who work together
                        towards a common goal — <em>to tackle the challenge of the climate crisis </em>
                        and to make a meaningful contribution to secure the future of humanity.
                    </GradientText>
                    <Button type="learn-more-arrow" className="business-philosophy-button">
                        LEARN MORE ABOUT US
                    </Button>
                </div>
            </div>
        </div>
    </section>
);

export default AboutUs;
